import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";

interface NavbarProps {
  isLoggedIn: boolean;
  modules: { id: number; title: string; url: string }[];
  handleLogout: () => void; // Add the handleLogout prop
}

const Navbar: React.FC<NavbarProps> = ({ isLoggedIn, handleLogout }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  const hideNavBaseRoutes = [
    "/events",
    "/music",
    "/divisions",
    "/performances",
    "/scorecard",
    "/admin/users",
    "/admin/performances",
    "/placements",
  ];

  const shouldHideSection = hideNavBaseRoutes.some((baseRoute) =>
    location.pathname.startsWith(baseRoute)
  );

  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const crrUserData = localStorage.getItem("user");

  return (
    <div className={styles.topwcontainer}>
      <div className={styles.wcontainer}>
      <nav className={styles.nav}>
        
        <div
          className={styles.nav__menuIconBox}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <img src="./images/menu-icon.svg" className={styles.menuIcon} />
        </div>
        <div className={`${styles.nav__logoBox} ${styles.logodesktop}`}>
          <Link
            to={
              isLoggedIn && (currentRole == "1" || currentRole == "8")
                ? "/admin-dashboard"
                : isLoggedIn
                ? "/competitions"
                : "/"
            }
            className="nav-link "
            onClick={() => setIsMenuOpen(false)}
          >
            <img
              src="/images/Judging-Logo-white.png"
              loading="lazy"
              alt="Judging Logo"
              className={styles.nav__logo}
            />
          </Link>
        </div>
        {crrUserData ? 
        <div className="header-name">Hi, {
          JSON.parse(crrUserData || '{}').first_name 
          // + " " + JSON.parse(crrUserData || '{}').last_name
          }</div>
        : ''
        }
        
        <div
          className={`${styles.nav__linkBox} ${
            isMenuOpen ? styles.nav__menuLinkBoxOpen : ""
          }`}
        >
          <Link
            to={
              isLoggedIn && (currentRole == "1" || currentRole == "8")
                ? "/admin-dashboard"
                : isLoggedIn
                ? "/competitions"
                : "/"
            }
            className="nav-link w-nav-link"
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <>
            {!isLoggedIn ? (
              <Link
                to="/login"
                className="nav-link w-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                Login
              </Link>
            ) : (
              <>
                {(currentRole == "1" || currentRole == "8") ? (
                  <Link
                    to="/admin-dashboard"
                    className="nav-link w-nav-link"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Admin
                  </Link>
                ) : (
                  <Link
                    to="/competitions"
                    className="nav-link w-nav-link"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Competitions
                  </Link>
                )}
                 <Link
                  to="/edit-profile"                  
                  className="nav-link w-nav-link"
                >
                  Edit Profile
                </Link>
                <Link
                  to="/login"
                  onClick={() => {
                    setIsMenuOpen(false);
                    handleLogout();
                  }}
                  className="nav-link w-nav-link"
                >
                  Logout
                </Link>
              </>
            )}
          </>
        </div>
        
      </nav>
      </div>
      <div>
        {!shouldHideSection && (
          <section className="home-hero-section">
            <h1 className="judgingapp-hero-heading">
              Together We Dance Competition.
            </h1>
          </section>
        )}
      </div>
    </div>
  );
};

export default Navbar;
